import { render, staticRenderFns } from "./OsStatisticsCardDiscDistribution.vue?vue&type=template&id=2be4eaee&scoped=true"
import script from "./OsStatisticsCardDiscDistribution.vue?vue&type=script&lang=ts"
export * from "./OsStatisticsCardDiscDistribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be4eaee",
  null
  
)

export default component.exports